import React from "react";

import { Palette } from "../@shared/palette";

export type UseBadgeProps = {

}

export type UseBadgeResult = {
    getBadgeColor: (text: string) => BadgeColorResult;
}

export type BadgeColorResult = {
    backgroundColor: string;
    textColor: string;
}

export const useBadge = (): UseBadgeResult => {
    const getBadgeColor = React.useCallback((text: string) => {
        let hash = 0;
        for (let i = 0; i < text.length; i++) {
            hash = text.charCodeAt(i) + ((hash << 5) - hash);
        }

        const color = `rgba(${(hash >> 24) & 0xFF}, ${(hash >> 16) & 0xFF}, ${(hash >> 8) & 0xFF}, .85)`;

        const rgb = color.match(/\d+/g)!.map(Number);
        const luminance = 0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2];
        const textColor = luminance > 128 ? Palette.textColorPrimary : Palette.textColorPrimaryContrast;

        return { backgroundColor: color, textColor };
    }, [])

    return {
        getBadgeColor
    }
}